(function () {
  function query(selector, context) {
    return (context || document).querySelector(selector);
  }

  function queryAll(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function on(selector, eventName, handler) {
    queryAll(selector).forEach(function (el) {
      el.addEventListener(eventName, handler);
    });
  }

  function parseBool(value) {
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value == null) return false;
    var normalized = String(value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on';
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isDesktopNavViewport() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var helpers = {
      query: query,
      queryAll: queryAll,
      on: on,
      parseBool: parseBool,
      isMobileViewport: isMobileViewport,
      isDesktopNavViewport: isDesktopNavViewport,
    };

    var moduleOrder = ['nav', 'hero', 'categories', 'featuredProducts', 'collection', 'home', 'footer', 'product'];

    moduleOrder.forEach(function (name) {
      if (!window.SPCLST || !window.SPCLST.modules) return;
      var init = window.SPCLST.modules[name];
      if (typeof init !== 'function') return;

      try {
        init(helpers);
      } catch (error) {
        console.error('[SPCLST] Failed to initialize module:', name, error);
      }
    });
  });
})();
